export const STOCK_CARD_TYPE = Object.freeze({
  QR_ONLINE: 'qr-online',
  QR: 'qr',
  STORE: 'store',
})

export default STOCK_CARD_TYPE
